import React from 'react'
import styled from 'styled-components'

import { FormNavigation } from '@prehook/shared'

const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px 20px;
  /* the strip overlays quiz content (e.g. Add To Cart) — clicks must pass
     through everywhere except the nav arrows */
  pointer-events: none;
`

const NavigationWrapper = styled.div`
  pointer-events: auto;
`

const Footer = ({ nextPage, prevPage, allowNext, allowPrev, color }) => {
  return (
    <FooterWrapper>
      {/* <FormProgressBar /> */}
      <NavigationWrapper>
        <FormNavigation
          next={nextPage}
          prev={prevPage}
          allowNext={allowNext}
          allowPrev={allowPrev}
          color={color}
        />
      </NavigationWrapper>
    </FooterWrapper>
  )
}

export default Footer
